// Offer-URL resolution (Consolidation §4.2 / §6.3). After this restructure
// the Promotion Plan is the sole authoring surface for these two URLs —
// they were removed from Campaign. A Rollout surface resolves them live
// from the Rollout's parent Plan (via rollout.promotionPlanId); orphan
// Rollouts (no parent Plan) have no source, so the answer is null. There
// is deliberately NO fallback to Campaign — the fields no longer exist
// there.
//
// Pure + structural input so both the wire `PromotionPlan` and the
// server's `StoredPromotionPlan` satisfy it.

type PlanWithOfferUrls = {
  offerMechanicsUrl: string | null;
  kyckCampaignOverviewUrl: string | null;
};

export function resolveOfferMechanicsUrl(
  plan: PlanWithOfferUrls | null | undefined,
): string | null {
  return plan?.offerMechanicsUrl ?? null;
}

export function resolveKyckCampaignOverviewUrl(
  plan: PlanWithOfferUrls | null | undefined,
): string | null {
  return plan?.kyckCampaignOverviewUrl ?? null;
}
